// initial status
const filterRedux = {
  assignFilter: { status: "" },
  assignSearch: "",
  medicalSearch: "",
  manageMeeting: "",
  medicalFilter: "",
};

//action

export const filterActionAdd = (data) => {
  return {
    type: "FILTER_STATUS_ADD",
    data: data,
  };
};

// -------------------------------REDUCER-------------------------

export const filterReducerTraining = function (state = filterRedux, action) {
  switch (action.type) {
    case "FILTER_STATUS_ADD": {
      return (state = {
        ...state,
        ...action.data,
      });
    }

    default:
      return state;
  }
};
